const sharedProps = {
  contact: {
    displayPhotoUrl:
      'https://images.ctfassets.net/wzzep3ntdgx4/2Y0U88SwWfKHFqtRZppZto/d937fed14ac94f772748b4d9e2ab2add/Screen_Shot_2022-05-22_at_6.22.22_PM.png',
    languages: 'Spanish',
    displayPrimary: 'Jason Kenson',
    displaySecondary: 'Team Kenson',
    displayPhone: '555-555-5555',
    displayEmail: 'hello@example.com',
    displayWebsiteUrl: 'https://www.sibcycline.com',
    professionalTitle: 'Realtor',
    websiteUrl: 'https://www.sibcycline.com',
    isOhioLicensed: true,
    isKentuckyLicensed: true,
    isIndianaLicensed: true
  }
};

export default {
  horizontalLarge: {
    ...sharedProps,
    theme: 'horizontalLarge'
  },
  horizontalSmall: {
    ...sharedProps,
    theme: 'horizontalSmall'
  },
  officeDetail: {
    ...sharedProps,
    theme: 'officeDetail'
  },
  primary: {
    ...sharedProps,
    theme: 'primary'
  },
  props: {
    ...sharedProps
  }
};
